/**
 * @namespace Background
 * @memberof Promega.Components
 * @description Polyfills object-fit for Content Width backgrounds in Internet Explorer. Does not expose any methods externally.
 */

import { v4 as uuid } from 'uuid';

if (!("objectFit" in document.documentElement.style)) {
    const backgroundImages = document.querySelectorAll("img.background-element, video.background-element");
    for (let i = 0; i < backgroundImages.length; i++) {
        const item = backgroundImages[i],
            imgSrc = item.tagName.toLowerCase() === "img" ? item.getAttribute("src") : item.getAttribute("poster"),
            backgroundConfig = item.className.split(" ").filter(cssClass => cssClass.indexOf("background-element") > -1);

        if (imgSrc) {
            item.parentElement.style.backgroundImage = `url("${imgSrc}")`;
            item.parentElement.classList.add("has-background--compat");
            for (let k = 0; k < backgroundConfig.length; k++) {
                const configType = backgroundConfig[k].substr("background-element--".length);
                if (configType.length > 0) item.parentElement.classList.add(`has-background--compat-${configType}`);
            }
            item.parentElement.removeChild(item);
        }
    }
}

document.addEventListener('lazybeforeunveil', event => {
    if (event.target.classList.contains('has-image-background') || event.target.classList.contains('has-pattern-background')) {
        event.preventDefault();
        if (!(window.CSS && CSS.supports('color', 'var(--primary)'))) {
            // No support for custom properties. Shim: get image from data-attribute
            const newStyle = document.createElement('style');
            const bgid = `bg-${uuid().slice(0,8)}`;
            newStyle.innerHTML = `.${bgid}{background-image:url("${event.target.dataset.bg}")}`;
            document.head.insertBefore(newStyle, document.head.children[0]);
            event.target.classList.add(bgid);
        }
    }
});

function getCssValue(element, property) {
    let propertyValue = window.getComputedStyle(element).getPropertyValue(property);
    if (propertyValue) {
        return propertyValue;
    }
}

function calcImgRatioPadding(width, height) {
    let ratio = ((Math.round(height) / Math.round(width)) * 100).toFixed(2);
    return ratio.replace(".00", "");
}


// Init code
{
    const elementList = document.querySelectorAll('.has-full-height-background');

    for (let i = 0; i < elementList.length; i++) {
        try {
            let currentElement = elementList[i];
            const propertyValue = getCssValue(currentElement, "--background-image");
            if (propertyValue == null) {
                throw new Error(`Could not find background image property for element: ${currentElement}`);
                continue;
            }
            const urlMatch = propertyValue.match(/url\(['"]?(.*?)['"]?\)/);
            const urlValue = urlMatch ? urlMatch[1] : null;
            if (urlValue == null) {
                throw new Error(`Could not find url for element: ${currentElement}`);
                continue;
            }

            let imgConst = new Image();
            imgConst.src = urlValue;

            imgConst.onload = () => {
                let imgPadding = calcImgRatioPadding(imgConst.width, imgConst.height);
                currentElement.style.paddingTop = imgPadding + "%";
            }

            imgConst.onerror = (event) => {
                console.error("Failed to load image:", urlValue);
                console.error("Error Event:", event);
            };
        } catch (error) {
            console.error(error);
        }
    }
}